import { z } from 'zod';

import { EscrowDueId, EscrowSettingId, LosId, PropertyId } from '../../BrandedIds';
import { EscrowInsuranceType, EscrowSettingStatus, TaxEscrowType } from '../../loan/EscrowSetting';
import { zodTemporalPlainDate } from '../../Temporal';
import { NonNegativeMonetaryValue } from '../../validations/fields';

export const ExportableEscrowDue = z
  .object({
    id: EscrowDueId,
    loanId: LosId,

    propertyId: PropertyId,
    escrowSettingId: EscrowSettingId,
    dueDate: zodTemporalPlainDate,
    estimatedAmount: NonNegativeMonetaryValue,
    amountPaid: NonNegativeMonetaryValue,
    escrowed: z.boolean(),
    fulfilled: z.boolean(),
    status: EscrowSettingStatus,
    type: z.enum(['tax', 'insurance', 'mortgageInsurance']),
    taxType: TaxEscrowType.optional(),
    insuranceName: z.string().optional(),
    insuranceType: EscrowInsuranceType.optional(),
  })
  .meta({ title: 'EscrowDue' });

export type ExportableEscrowDue = z.infer<typeof ExportableEscrowDue>;
